<template>
  <div
    v-click-outside="hideList"
    class="custom-select"
    style="width: 100%"
  >
    <div>
      <input v-enter-to-tab type="text" class="input-field EnterToTab" :value="inputValue" :disabled="viewMode"
             @click="showList" @input="onInput" @keydown="keydownHandler" />
      <smtt-icon
        class="icon"
        :icon="showClear ? 'close' : 'search'"
        @click="handleIconClick"
      />
    </div>
    <div
      v-show="showPopUp"
      class="shadow-card select-popup"
    >
      <div class="options-box">
        <div
          v-for="option in filteredQuestionOptions"
          :key="option.id"
          class="p-3"
          @click="answered(option.id)"
        >
          <input :id="option.id" v-enter-to-tab type="radio" :name="questionId" :checked="option.selected"
                 :class="`m-2 align-middle ${showPopUp ? 'EnterToTab' : '' }`" :value="option.name" />
          <label
            class="align-middle m-0"
            :for="option.id"
          >
            {{ option.name }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  'name': 'SelectionOptionSearch',
  'props': {
    'questionId': 0,
    'questionOptions': {},
    'viewMode': {
      'type': Boolean,
      'required': false
    }
  },
  data() {
    return {
      'showPopUp': false,
      'inputValue': '',
      'filteredQuestionOptions': [],
      'showClear': false,
    }
  },
  watch: {
    questionOptions(newValue) {
      const selectedQuestion = newValue.find((quest) => quest.selected);

      if (selectedQuestion) {
        this.inputValue = selectedQuestion.name;
        this.showClear = true;
      } else {
        this.inputValue = '';
        this.showClear = false;
      }
    }
  },
  'methods': {
    response() {
      this.$emit('onAnswered')
    },
    handleIconClick() {
      if (this.viewMode) {
        return;
      }

      if (this.showClear) {
        this.filteredQuestionOptions = this.questionOptions.map((option) => {
          return { ...option, selected: false }
        });

        this.$emit('onHideConditional', this.filteredQuestionOptions, false)
        this.inputValue = '';
        
        this.$emit('onAnswered', this.filteredQuestionOptions)
      } else {
        this.showList()
      }
    },
    answered(questionOptionId) {
      this.hideList()
      let selectedIndex;
      const questionOptions = this.questionOptions.map((option, index) => {
        if (option.id === questionOptionId) {
          selectedIndex = index;
          return { ...option, 'selected': true };
        } else {
          return { ...option, 'selected': false };
        }
      })
      this.$emit('onHideConditional', questionOptions, false)
      this.inputValue = questionOptions[selectedIndex].name;

      if (questionOptions[selectedIndex].conditional) {
        this.$emit('onShowConditional', questionOptions[selectedIndex], true)
      }
      this.$emit('onAnswered', questionOptions)
    },
    hideList() {
      this.showPopUp = false;
    },
    showList() {
      if (!this.viewMode) {
        if (this.showPopUp) {
          this.hideList()
        } else {
          this.showPopUp = true
        }
      }
    },
    checkConditionals() {
      this.questionOptions.forEach((option) => {
        if (option.conditional) {
          this.$emit('onShowConditional', option, option.selected)
        }
      })
    },
    onInput(e) {
      this.inputValue = e.target.value;
      const value = e.target.value.trim();

      if (value.length > 0) {
        this.showClear = true;
      } else {
        this.showClear = false;
      }

      if (value.length > 3) {
        this.filteredQuestionOptions = this.questionOptions.filter((question) => 
          question.name.toLowerCase().includes(value.toLowerCase())
        );
      } else {
        this.filteredQuestionOptions = Array.from(this.questionOptions);
      }
    },
    keydownHandler(event) {
      if(event.key === ' ') {
        event.preventDefault()

        this.showList()
      }
    }
  },
  created() {
    this.filteredQuestionOptions = Array.from(this.questionOptions);

    const selectedQuestion = this.questionOptions.find((quest) => quest.selected);
    if (selectedQuestion) {
      this.inputValue = selectedQuestion.name;
      this.showClear = true;
    }
    this.checkConditionals()
  }
}

</script>
<style scoped>
.custom-select {
  position: relative;
  display: inline-block;
}

.select-popup {
  position:absolute;
  list-style: none;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border-radius: 4px;
  z-index: 2;
}

.options-box {
  max-height: 20em;
  overflow-y: scroll;
}

.input-field {
  border: 1px solid #4c4d57;
  border-radius: 0.2rem;
  height: 40px;
  width: 100%;
  padding: 0.375rem 0.75rem;
  color: #495057;
}

.input-field:focus {
  box-shadow: 0 0 1px 2px #006FFF;
  outline: 0;
}

.icon {
  position: absolute;
  right: 0;
  padding: 8px;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.icon:hover {
  background-color: #d2d2d2;
  border-top: 1px solid #4c4d57;
  border-right: 1px solid #4c4d57;
  border-bottom: 1px solid #4c4d57;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
  padding: 7px
}
</style>
